<template>
    <div class="elektrophile-addition-mechanismus">
        <img
            src="@/assets/img/reaktionen/elektrophile-addition/elektrophile-addition.png"
            alt="Elektrophile Addition"
            title="Elektrophile Addition"
        />
        <small
            ><a
                href="http://jagemann-net.de/chemie/reaktionen/EA/EA.php"
                target="_blank"
                >Quelle</a
            ></small
        >
    </div>
</template>

<script>
export default {
    name: 'elektrophile-addition-mechanismus',
};
</script>
